// Components/Modals/AddPolicyModal.jsx
import React, { useState } from 'react';

const AddPolicyModal = ({ isOpen, onClose, onSubmit, portalSettings }) => {
    const [formData, setFormData] = useState({
        polNo: '',
        firstName: '',
        lastName: '',
        last4SSN: '',
        birthDate: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    if (!isOpen) return null;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3 className="baseHeader">Add Policy</h3>
                <form onSubmit={handleSubmit} className="baseForm">
                    <label className="baseLabel">Policy Number</label>
                    <input className="baseInput" name="polNo" value={formData.polNo} onChange={handleChange} required />

                    <label className="baseLabel">First Name</label>
                    <input className="baseInput" name="firstName" value={formData.firstName} onChange={handleChange} required />

                    <label className="baseLabel">Last Name</label>
                    <input className="baseInput" name="lastName" value={formData.lastName} onChange={handleChange} required />

                    <label className="baseLabel">{psm.birthDateRegisterType} Date of Birth</label>
                    <input className="baseInput" type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} required />

                    <label className="baseLabel">Last 4 SSN</label>
                    <input className="baseInput" name="last4SSN" value={formData.last4SSN} onChange={handleChange} maxLength={4} required />

                    <button type="submit" className="baseButton">Submit</button>
                    <button type="button" className="baseButton secondary" onClick={onClose}>Cancel</button>
                </form>
            </div>
        </div>
    );
};

export default AddPolicyModal;
